import { useEffect } from 'react'

interface ModalProps {
  open: boolean
  onClose: () => void
  title: string
  children: React.ReactNode
}

export function Modal({ open, onClose, title, children }: ModalProps) {
  useEffect(() => {
    if (!open) return
    const handleEsc = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose()
    }
    document.addEventListener('keydown', handleEsc)
    return () => document.removeEventListener('keydown', handleEsc)
  }, [open, onClose])

  if (!open) return null

  return (
    <div
      className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-4"
      onClick={onClose}
    >
      <div
        // Inline width — Tailwind's `max-w-md` was somehow not clipping
        // in prod build (modal stretched to content width). Explicit
        // CSS values are robust to that. `min-w-0` neutralises flex's
        // default `min-width: auto`. `whitespace-normal` resets inherited
        // `white-space: nowrap` from ancestors like `<td class="whitespace-
        // nowrap">` — the modal is `position: fixed` but CSS inheritance
        // follows the DOM, not the visual tree, so text inside would not
        // wrap if the trigger lives in a no-wrap cell.
        style={{ width: '100%', maxWidth: '28rem' }}
        className="bg-white dark:bg-gray-900 rounded-xl p-6 shadow-xl text-left min-w-0 whitespace-normal"
        onClick={e => e.stopPropagation()}
      >
        <h2 className="text-lg font-semibold text-gray-900 dark:text-gray-100 mb-3 text-left">
          {title}
        </h2>
        {children}
      </div>
    </div>
  )
}
